module.exports = __webpack_public_path__ + "img/bottom_mx.6567d8ed.png";